import quickFetch from 'quick-fetch';

const gateName = 'hs-resources:FullSearchRPC';

let cachedResult: Promise<boolean> | undefined;

export const __TEST_ONLY_setSearchRpcGate = (value: 'true' | 'false') => {
  cachedResult = Promise.resolve(value === 'true');
};

export const __TEST_ONLY_resetSearchRpcGate = () => {
  cachedResult = undefined;
};

const checkSearchRpcGate = () =>
  new Promise<boolean>((resolve) => {
    if (!quickFetch.getLoginVerifyRequest()) {
      resolve(false);
      return;
    }

    const safetyTimeout = setTimeout(() => resolve(false), 1000);

    quickFetch.afterAuth((auth) => {
      clearTimeout(safetyTimeout);
      resolve(auth.portal.enabled_v3_gates?.includes(gateName) ?? false);
    });
  });

export const isSearchRpcGateEnabled = () => {
  cachedResult = cachedResult ?? checkSearchRpcGate();
  return cachedResult;
};
